import { Component } from 'react'
import { Container, Row, Col } from 'reactstrap'
import withApolloClient from '../../withApolloClient'
import RestrictedSection from "../../Components/RestrictedSection"

import TPAList from './TPAList'
import TPAActions from './TPAActions'
import TPAListHeader from './TPAListHeader'


const tableHeaders = [
    { id: "date_added", name: "Date Added", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "date_modified", name: "Date Modified", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "name", name: "Name", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "feeType", name: "Fee Type", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "feeAmount", name: "Fee Amount", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "contactName", name: "Contact Name", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "contactEmail", name: "Contact Email", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "contactPhone", name: "Contact Phone", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "description", name: "Description", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
]
const getDefaultColumnConfig = () => tableHeaders.map((column, index) => ({ ...column, order: index }))

class IncidentListContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            orderBy: ["-date_added"],
            filterValues: {},
            refetchTPAList: false,
            columnConfig: getDefaultColumnConfig(),
        }
    }
    setColumnConfig = (columnConfig) => this.setState({ columnConfig })

    updateOrder = (string) => {
        let order = this.state.orderBy ? [...this.state.orderBy] : []
        let index = order.indexOf(string)
        if (index > -1) {
            order[index] = "-" + string
        } else {
            index = order.indexOf("-" + string)
            index > -1 ? order.splice(index, 1) : order.unshift(string)
        }
        this.setState({ orderBy: order })
    };


    render() {
        return (
            <RestrictedSection requiredPermission="view_tpa">
                <Container fluid className="bos-listing-container">
                    <Row>
                        <Col xs={8}>
                            <TPAListHeader
                                filterValues={this.state.filterValues}
                                setFilterValues={(filterValues) => this.setState({ filterValues })}
                                defaultFilters={this.state.filterValues}
                                {...this.props}
                            />
                        </Col>
                        <Col xs={4}>
                            <TPAActions
                                columnConfig={this.state.columnConfig}
                                setColumnConfig={this.setColumnConfig}
                                tableId="tpa"
                                defaultColumnConfig={getDefaultColumnConfig()}
                                refetchQuery={() => this.setState({ refetchTPAList: !this.state.refetchTPAList })}
                                {...this.props}
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col sm="12">
                            <TPAList
                                columnConfig={this.state.columnConfig}
                                key={String(this.state.refetchTPAList)}
                                currentUser={this.props.currentUser}
                                searchTerm={this.state.filterValues && this.state.filterValues.searchTerm ? this.state.filterValues.searchTerm : null}
                                orderBy={this.state.orderBy}
                                updateOrder={this.updateOrder}
                            />
                        </Col>
                    </Row>
                </Container>
            </RestrictedSection>
        )
    }
}



export default withApolloClient(
    IncidentListContainer
)
